import { render, staticRenderFns } from "./OrderBoxesList.vue?vue&type=template&id=116e929e&"
import script from "./OrderBoxesList.vue?vue&type=script&lang=js&"
export * from "./OrderBoxesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports